import MicroModal from 'micromodal';

/**
 * We've used MicroModal as it handles all the keyboard click states for accesibility
	* Ensure all modals have a open / exit animations
	* Library uses awaitTransitionEnd to open / exit
	* Triggers operate using a data-{trigger}-open, data-{trigger}-close attributes
 */

export function globalModals() {
	const modals = document.querySelectorAll('.global-modal');
	Modals.init(modals)
}

export function pageModals() {
	const modals = document.querySelectorAll('.page-modal');
	Modals.init(modals, 'page')
}

const Modals = (() => {
	const body = document.body;
	const m = {
		instances: [],
		defaultSelector: 'global',
		openTrigger: undefined,
		exitTrigger: undefined,
	}

	m.init = (modals, selector = 'global') => {
		if(!modals.length) {
			return
		}

		let modalSelector = m.defaultSelector;
		if(selector) {
			modalSelector = selector;
		}

		m.instances = Array.from(modals);
		m.openTrigger = `data-${modalSelector}-open`;
		m.exitTrigger = `data-${modalSelector}-close`;

		MicroModal.init({
			onShow: modal => m.open(modal),
			onClose: modal => m.close(modal),
			openTrigger: m.openTrigger,
			closeTrigger: m.exitTrigger,
			openClass: 'is-open',
			disableScroll: false,
			disableFocus: false,
			awaitOpenAnimation: true,
			awaitCloseAnimation: true,
			debugMode: true,
		});
	}

	m.open = (currentModal) => {
		m.instances.forEach((modal) => {
			const isActive = modal.classList.contains('is-open');

			if(isActive && (modal.id !== currentModal.id)) {
				modal.querySelector(`[${m.exitTrigger}]`).click();
			}
		})

		if(!body.classList.contains('modal-active')) {
			body.classList.add('modal-active');
		}
	}

	m.close = (currentModal) => {
		// Check for modals, remove class none are active
		const modalsActive = m.instances.filter((modal) => {
			return modal.getAttribute('aria-hidden') === 'false';
		}).length > 0

		if(!modalsActive) {
			body.classList.remove('modal-active')
		}
	};

	return m;
})()



// WEBPACK FOOTER //
// ./scripts/modules/modals.js